import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import MainLayout from '../components/layout/MainLayout';

const HomePage = lazy(() => import('../pages/home/page'));
const QuemSomosPage = lazy(() => import('../pages/quem-somos/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const SeguroAutoPage = lazy(() => import('../pages/seguros/seguro-auto/page'));
const SeguroVidaPage = lazy(() => import('../pages/seguros/seguro-vida/page'));
const SeguroEmpresarialPage = lazy(() => import('../pages/seguros/seguro-empresarial/page'));
const SeguroResidencialPage = lazy(() => import('../pages/seguros/seguro-residencial/page'));
const SeguroPatrimonialPage = lazy(() => import('../pages/seguros/seguro-patrimonial/page'));
const SeguroIncendioPage = lazy(() => import('../pages/seguros/seguro-incendio/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const PoliticaPrivacidadePage = lazy(() => import('../pages/politica-privacidade/page'));
const CotacaoPage = lazy(() => import('../pages/cotacao/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const GestaoDeContratosPage = lazy(() => import('../pages/estrategia/gestao-de-contratos/page'));
const ConsultoriaTecnicaPage = lazy(() => import('../pages/estrategia/consultoria-tecnica/page'));
const SuporteAcompanhamentoPage = lazy(() => import('../pages/estrategia/suporte-acompanhamento/page'));
const TaxaCorretagemPage = lazy(() => import('../pages/taxa-corretagem/page'));
const TechnicalAuditPage = lazy(() => import('../pages/technical-audit/page'));
const AdminChatPage = lazy(() => import('../pages/admin/page'));
const ComunidadePage = lazy(() => import('../pages/comunidade/page'));
const AccessibilityAuditPage = lazy(() => import('../pages/accessibility-audit/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/quem-somos', element: <QuemSomosPage /> },
      { path: '/servicos', element: <ServicosPage /> },
      { path: '/seguros/seguro-auto', element: <SeguroAutoPage /> },
      { path: '/seguros/seguro-vida', element: <SeguroVidaPage /> },
      { path: '/seguros/seguro-empresarial', element: <SeguroEmpresarialPage /> },
      { path: '/seguros/seguro-residencial', element: <SeguroResidencialPage /> },
      { path: '/seguros/seguro-patrimonial', element: <SeguroPatrimonialPage /> },
      { path: '/seguros/seguro-incendio', element: <SeguroIncendioPage /> },
      { path: '/blog', element: <BlogPage /> },
      {
        path: '/blog/como-escolher-seguro-auto-ideal',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/como-escolher-seguro-auto-ideal/page');
          return { Component };
        },
      },
      {
        path: '/blog/economizar-no-seguro-sem-perder-cobertura',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/economizar-no-seguro-sem-perder-cobertura/page');
          return { Component };
        },
      },
      {
        path: '/blog/seguro-de-vida-guia-completo',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/seguro-de-vida-guia-completo/page');
          return { Component };
        },
      },
      {
        path: '/blog/seguros-essenciais-para-pmes',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/seguros-essenciais-para-pmes/page');
          return { Component };
        },
      },
      {
        path: '/blog/entenda-taxa-de-corretagem',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/entenda-taxa-de-corretagem/page');
          return { Component };
        },
      },
      {
        path: '/blog/seguro-residencial-apartamento-alugado',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/seguro-residencial-apartamento-alugado/page');
          return { Component };
        },
      },
      {
        path: '/blog/seguro-saude-como-escolher-plano-ideal',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/seguro-saude-como-escolher-plano-ideal/page');
          return { Component };
        },
      },
      {
        path: '/blog/seguro-viagem-guia-completo',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/seguro-viagem-guia-completo/page');
          return { Component };
        },
      },
      {
        path: '/blog/seguro-para-mei-protecao-essencial',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/seguro-para-mei-protecao-essencial/page');
          return { Component };
        },
      },
      {
        path: '/blog/previdencia-privada-vs-seguro-de-vida',
        lazy: async () => {
          const { default: Component } = await import('../pages/blog/previdencia-privada-vs-seguro-de-vida/page');
          return { Component };
        },
      },
      { path: '/contato', element: <ContatoPage /> },
      { path: '/politica-privacidade', element: <PoliticaPrivacidadePage /> },
      { path: '/cotacao', element: <CotacaoPage /> },
      {
        path: '/cotacao/obrigado',
        lazy: async () => {
          const { default: Component } = await import('../pages/cotacao/obrigado/page');
          return { Component };
        },
      },
      { path: '/cases', element: <CasesPage /> },
      { path: '/estrategia/gestao-de-contratos', element: <GestaoDeContratosPage /> },
      { path: '/estrategia/consultoria-tecnica', element: <ConsultoriaTecnicaPage /> },
      { path: '/estrategia/suporte-acompanhamento', element: <SuporteAcompanhamentoPage /> },
      { path: '/taxa-corretagem', element: <TaxaCorretagemPage /> },
      { path: '/comunidade', element: <ComunidadePage /> },
      { path: '/faq', element: <FAQPage /> },
      {
        path: '/accessibility-audit',
        element: <AccessibilityAuditPage />,
      },
    ],
  },
  {
    path: '/technical-audit',
    element: <TechnicalAuditPage />,
  },
  {
    path: '/admin',
    element: <AdminChatPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
